export const HASHTAG_REGEX = new RegExp(
  /(?!\s)#[A-Za-z0-9_-]+\b(?![x0-9A-z;])/g
);
